export const Condicao = {
  7: 'Sucata',
  9: 'Bom',
  10: 'Regular',
  11: 'Ruim',
  12: 'Péssimo'
}

export const StatusArremate = {
  0: 'Condicional/Aguardando liberação',
  1: 'Aprovado',
  2: 'Entregue',
  3: 'Arrematante desistiu',
  4: 'Cancelado'
}

export const Status = {
  0: {titulo: 'Rascunho', class: 'light', color: '#FFFFFF'},
  1: {titulo: 'Aberto', class: 'black', color: '#FFFFFF'},
  2: {titulo: 'Em Pregão', class: 'info', color: '#FF7F00'},
  3: {titulo: 'Doulhe-uma', class: 'warning', color: '#FFFF00'},
  4: {titulo: 'Doulhe-duas', class: 'warning', color: '#FE2C31'},
  5: {titulo: 'Homologando', class: 'primary', color: '#007FFF'},
  6: {titulo: 'Vendido', class: 'success', color: '#7FFF00'},
  7: {titulo: 'Condicional', class: 'light', color: '#FFCC99'},
  8: {titulo: 'Sem Licitantes', class: 'black', color: '#FFBFFF'},
  9: {titulo: 'Baixa Oferta', class: 'black'},
  10: {titulo: 'Retirado', class: 'danger'},
  11: {titulo: 'Fechado', class: 'black'}
}

export const StatusTitle = function (s) {
  if (typeof Status[s] === 'undefined') {
    return 'Unknow status code'
  }
  return Status[s].titulo
}

export const STATUS_RASCUNHO = 0
export const STATUS_ABERTO_PARA_LANCES = 1
export const STATUS_EM_PREGAO = 2
export const STATUS_DOULHE_UMA = 3
export const STATUS_DOULHE_DUAS = 4
export const STATUS_HOMOLOGANDO = 5
export const STATUS_VENDIDO = 6
export const STATUS_CONDICIONAL = 7
export const STATUS_SEM_LICITANTES = 8
export const STATUS_BAIXA_OFERTA = 9
export const STATUS_RETIRADO = 10
export const STATUS_FECHADO = 11



// WEBPACK FOOTER //
// ./src/domain/leiloes/helpers/LoteStatus.js